<template>
    <div>
        <div class="chart-wrapper" v-if="$i18n.locale=='en'">
            <div class="chart">
                <ul>
                    <li class="main">
                        <div class="box green">
                            <span>Board of Directors</span>
                        </div>
                        <ul class="main-sub">
                            <li>
                                <div class="box">
                                    <span>Board Secretary</span>
                                </div>
                            </li>
                        </ul>
                        <ul class="sub-categories">
                            <li>
                                <div class="box green">
                                    <span>Board Nominations and Remunerations Committee</span>
                                </div>
                            </li>
                            <li>
                                <div class="box green">
                                    <span>Vice Chairman and Group CEO</span>
                                </div>
                                <div class="multi-items">
                                    <ul>
                                        <li>
                                            <div class="box">
                                                <span>Finance</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Strategy</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Human Resources</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Investment & Digital Services</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Legal Counsel</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Commercial</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Innovative Solutions </span>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="itemsTwo">
                                        <li>
                                            <div class="box">
                                                <span>Technology</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box big">
                                                <span>Corporate Communications Investor Relations & Corporate Governance</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Regulatory Affairs</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Corporate Sustainibility</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>PMO</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Wholesale & Roaming</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>Diversity & Inclusion</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <div class="box green">
                                    <span>Board Risk Committee</span>
                                </div>
                                <ul class="sub-item">
                                    <li>
                                        <div class="box">
                                            <span>Risk <br> Management</span>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <div class="box green">
                                    <span>Board Audit Committee</span>
                                </div>
                                <ul class="sub-item">
                                    <li>
                                        <div class="box">
                                            <span>Internal <br> Audit</span>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div class="chart-wrapper" v-if="$i18n.locale=='ar'">
            <div class="chart">
                <ul>
                    <li class="main">
                        <div class="box green">
                            <span>مجلس الإدارة</span>
                        </div>
                        <ul class="main-sub">
                            <li>
                                <div class="box">
                                    <span>أمين السر</span>
                                </div>
                            </li>
                        </ul>
                        <ul class="sub-categories">
                            <li>
                                <div class="box green">
                                    <span>لجنة الترشيحات والمكافآت </span>
                                </div>
                            </li>
                            <li>
                                <div class="box green">
                                    <span>نائب رئيس مجلس الإدارة والرئيس التنفيذي للمجموعة</span>
                                </div>
                                <div class="multi-items">
                                    <ul>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الشؤون المالية</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الاستراتيجيات</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الموارد البشرية</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الاستثمار والتحول الرقمي </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الشؤون القانونية</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الشؤون التجارية</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الحلول المبتكرة</span>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul class="itemsTwo">
                                        <li>
                                            <div class="box">
                                                <span>إدارة التكنولوجيا </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box big">
                                                <span>إدارة الاتصالات وعلاقات المستثمرين والحوكمة </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الشؤون التنظيمية</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة الاستدامة </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة المشاريع والعمليات</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة التجوال ومبيعات الجملة </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="box">
                                                <span>إدارة التنوع والاشتمال</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <div class="box green">
                                    <span>لجنة المخاطر </span>
                                </div>
                                <ul class="sub-item">
                                    <li>
                                        <div class="box">
                                            <span>إدارة المخاطر</span>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <div class="box green">
                                    <span>لجنة التدقيق</span>
                                </div>
                                <ul class="sub-item">
                                    <li>
                                        <div class="box">
                                            <span>إدارة التدقيق الداخلي</span>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.chart-wrapper { 
    margin: 30px 0; 
    height: 750px; 
    @media screen and (max-width:700px){
        overflow-x: scroll;
    }
}
.chart {     
    text-align: center; max-width: 665px; margin: auto;
    @media screen and(max-width:700px){
        width: 700px; 
        max-width: auto;  
    }
}
.chart ul { list-style: none; padding: 0; margin: 0;  }
.chart ul li { position: relative; }

.green{background-color: transparent !important}
.chart ul li .box {  text-align: center; line-height: 1.2; width: 130px;  height: 48px; position: relative; font-weight: 700; margin-bottom: 20px; display: inline-block; color: #fff; font-size: 12px;  padding: 3px; border: 1px solid #9d9fa1; }
.chart ul li .box.big{ height: 80px;}
.chart ul li .box span {padding: 2px; overflow: hidden;   display: flex; align-items: center; justify-content: center; letter-spacing: -.5px; width: 100%; height: 100%; }

.chart ul li .box.green span { background-color:transparent; }


.chart ul li.main > .box.green { width: 150px; font-size: 14px; margin-bottom: 50px; font-weight: 700; }
.chart ul li.main .main-sub {     position: absolute;    right: 10%; top: 0; }

.chart ul li ul.sub-categories { display: flex; /*align-items: center;*/ justify-content: space-between; } 
.chart ul li ul.sub-categories > li > .box { height: 60px; }

.chart ul li ul.sub-categories .multi-items {     display: flex; align-items: center; position: absolute; left: 50%; transform: translateX(-50%); margin-top: 120px; }
.chart ul li ul.sub-categories .multi-items ul:first-child { padding-right: 25px; }
.chart ul li ul.sub-categories .multi-items ul:last-child { padding-left: 25px;     margin-top: -35px; }
// .chart ul li ul.sub-categories .multi-items ul:first-child li:last-child .box { height: 80px; }


.chart ul li .box:before {
    position: absolute;
    background-color: #ffffff;
    color: #ffffff;
    border-radius: 100%;
    border: 1px solid #9d9fa1;
    width: 5px;
    height: 5px; 
}

.chart ul li.main > .box.green:before {
    content: '';
    bottom: -4px; left: 50%;
    transform: translateX(-50%);
}
.chart ul li.main .main-sub .box:before {
    content: ''; left: -4px;     top: 50%;
    transform: translateY(-50%);
}
.chart ul li ul.sub-categories > li > .box:before {
    content: '';
    top: -4px; left: 50%;
    transform: translateX(-50%);
}

.chart ul li ul.sub-categories .sub-item .box:before {
    content: '';
    top: -4px; left: 50%;
    transform: translateX(-50%);
}
.chart ul li ul.sub-categories .multi-items ul:first-child .box:before {
    content: ''; right: -4px; top: 50%;
    transform: translateY(-50%);
}
.chart ul li ul.sub-categories .multi-items ul:last-child .box:before {
    content: ''; left: -4px; top: 50%;
    transform: translateY(-50%);
}


.chart ul li .box:after {
    position: absolute;
    background: #9d9fa1;
    z-index: -1;
    width: 100%;
    height: 1px;
    right: 0;
}

.chart ul li.main .main-sub .box:after {
    content: '';
    left: -50%;
    width:50%;
    right: auto;
    top: 50%;
    transform: translateY(-50%);
}

.chart ul li.main > .box.green:after {
        content: '';
    left: 50%;
    transform: translateX(-50%);
    bottom: -27px;
    width: 1px;
    height: 30px;
    right: auto;
}

.chart ul li ul.sub-categories {
    position: relative;
}
.chart ul li ul.sub-categories:after {
    position: absolute;
    background: #9d9fa1;
    z-index: -1;
    height: 1px;
    content: '';
    left: 0px;
    right: 0;
    margin: auto;
    top: -25px;
    width: 80.65%;
}

.chart ul li ul.sub-categories > li > .box:after {
    content: '';
    left: 50%;
    transform: translateX(-50%);
    top: -25px;
    width: 1px;
    height: 26px;
    right: auto;
}

.chart ul li ul.sub-categories > li > .box span:before {
    position: absolute;
    background-color: #ffffff;
    color: #ffffff;
    border-radius: 100%;
    border: 1px solid #9d9fa1;
    width: 5px;
    height: 5px;
    content: '';
    bottom: -4px;
    left: 50%; transform: translateX(-50%);
}

.chart ul li ul.sub-categories > li:first-child > .box span:before { content: none; }

.chart ul li ul.sub-categories .sub-item .box:after {
    content: '';
    left: 50%;
    transform: translateX(-50%);
    top: -25px;
    width: 1px;
    height: 26px;
    right: auto;
}

.chart ul li ul.sub-categories .multi-items:after {
    position: absolute;
    background: #9d9fa1;
    z-index: -99999;
    content: '';
    left: 50%;
    transform: translateX(-50%);
    top: -138px;
    width: 1px;
    height: 119%;
}

.chart ul li ul.sub-categories .multi-items ul .box span:before {
    position: absolute;
    background-color: #ffffff;
    color: #ffffff;
    border-radius: 100%;
    border: 1px solid #9d9fa1;
    width: 5px;
    height: 5px;
    content: '';
    right: -30px;
    top: 50%;
    transform: translateY(-50%);
}

.chart ul li ul.sub-categories .multi-items ul:last-child .box span:before {
    left: -30px;
    right: auto;
}

.chart ul li ul.sub-categories .multi-items ul:first-child li:last-child .box:before , 
.chart ul li ul.sub-categories .multi-items ul:first-child li:last-child .box span:before {
        top: 32%;
}

.chart ul li ul.sub-categories .multi-items ul .box:after {
        content: '';
    right: -20%;
    left: auto;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
}
.chart ul li ul.sub-categories .multi-items ul li .box{margin-bottom:0;}
.chart ul li ul.sub-categories .multi-items ul li{margin-bottom:20px;}
.chart ul li ul.sub-categories .multi-items ul.itemsTwo li{margin-top:-20px; margin-bottom:40px;}
.chart ul li ul.sub-categories .multi-items ul:last-child .box:after {
    left: -20%;
    right: auto;
}

.chart ul li ul.sub-categories .multi-items ul:first-child li:last-child .box:after {
    top: 32%;
}
[lang="ar"]{
.chart-wrapper{
    direction:rtl;
}
.chart ul li.main .main-sub {left: 10%; right:auto;}
.chart ul li ul.sub-categories .multi-items ul:first-child { padding-left: 25px; padding-right:0; }
.chart ul li ul.sub-categories .multi-items ul:last-child { padding-right: 25px; padding-left:0; }

.chart ul li.main .main-sub .box:before {
    right: -4px;
    left:auto;
}

.chart ul li ul.sub-categories .multi-items ul:first-child .box:before {
    left: -4px;
    right:auto;
}
.chart ul li ul.sub-categories .multi-items ul:last-child .box:before {
    right: -4px; 
    left:auto;
}
.chart ul li .box:after {
    left: 0;
    right:auto;
}

.chart ul li.main .main-sub .box:after {
    right: -50%;
    left: auto;
}

.chart ul li.main > .box.green:after {
    left: 50%;
    transform: translateX(-50%);
    right: auto;
}


.chart ul li ul.sub-categories > li > .box:after {
    left: 50%;
    transform: translateX(-50%);
    right: auto;
}


.chart ul li ul.sub-categories .sub-item .box:after {
    content: '';
    left: 50%;
    transform: translateX(-50%);
    right: auto;
}

.chart ul li ul.sub-categories .multi-items:after {
    left: 50%;
    transform: translateX(-50%);
}

.chart ul li ul.sub-categories .multi-items ul .box span:before {
    left: -30px;
    right:auto;
}

.chart ul li ul.sub-categories .multi-items ul:last-child .box span:before {
    right: -30px;
    left: auto;
}


.chart ul li ul.sub-categories .multi-items ul .box:after {
    left: -20%;
    right: auto;
}
.chart ul li ul.sub-categories .multi-items ul:last-child .box:after {
    right: -20%;
    left: auto;
}

}
</style>